import ProfileTemplate from './ProfileTemplate';
export * from './ProfileTemplate';

export default ProfileTemplate;